import React from "react";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { formatDate } from "./formatDate";

const ExportToPDFCustomButton = ({
  data,
  fileName,
  columns,
  columnNames,
  buttonTitle,
  pageHeader,
}) => {
  const handleExport = () => {
    const doc = new jsPDF();

    // Map the data to only include selected columns and rename headers
    const filteredData = data.map((row, index) => {
      const newRow = [index + 1]; // Add record number as the first column
      columns.forEach((col) => {
        if (col === "date" || col.toLowerCase().includes("date")) {
          // Check if the date is valid and non-blank
          const dateValue = row[col];
          newRow.push(dateValue && isValidDate(dateValue) ? formatDate(dateValue) : ""); // Use blank if invalid
        } else {
          newRow.push(row[col]);
        }
      });
      return newRow;
    });
    
    // Helper function to validate date
    function isValidDate(date) {
      return !isNaN(new Date(date).getTime());
    }
    

    // Adding the table headers (including the 'Record No' column)
    const tableColumnHeaders = ["Record No", ...columnNames];

    // Footer: Add total pages and current page number
    const totalPagesExp = "{totalPages}"; // Placeholder for total pages

    // jsPDF autoTable settings with lines separating rows and columns
    doc.autoTable({
      head: [tableColumnHeaders], // Table header
      body: filteredData, // Table body
      didDrawPage: function (data) {
        const pageSize = doc.internal.pageSize;
        const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
        const pageHeight = pageSize.height
          ? pageSize.height
          : pageSize.getHeight();

        // Set font size for the footer
        doc.setFontSize(10);

        // Footer - current page number, aligned to the right
        doc.text(
          `Page ${data.pageNumber} of ${totalPagesExp}`,
          pageWidth - data.settings.margin.right,
          pageHeight - 10,
          { align: "right" }
        );

        // Header - set background color and text
        const headerHeight = 20; // Adjust the height of the header
        const headerColor = "#FFFFFF"; // Background color
        const textColor = "#000000"; // Text color

        // Draw the background rectangle
        doc.setFillColor(headerColor);
        doc.rect(0, 0, pageWidth, headerHeight, "F"); // Draw filled rectangle for the header

        // Center the header text
        const headerText = pageHeader;

        // Properly account for the document margins when centering
        //const pageMargin = data.settings.margin.left;
        // const availableWidth = pageWidth - pageMargin * 2; // Width excluding margins
        const headerX =
          (pageWidth -
            doc.getTextWidth(headerText) -
            (data.settings.margin.left + data.settings.margin.right)) /
          2; // pageMargin + (availableWidth - doc.getTextWidth(headerText)) / 2; // Center text within the available width
        const headerY = 18; // Adjust the vertical position of the header text
        doc.setFontSize(18);
        doc.setTextColor(textColor); // Set text color
        doc.text(headerText, headerX, headerY); // Draw the header text at the center
      },
      margin: { top: 20 }, // Increase the top margin to accommodate the header

      // Custom styles to add row and column separators
      styles: {
        lineColor: [0, 0, 0], // Black color for the lines
        lineWidth: 0.1, // Thickness of the separator lines
      },
      // Drawing vertical and horizontal lines
      drawCell: function (cell, data) {
        // Draw horizontal lines for rows
        doc.setDrawColor(0); // Black color
        doc.setLineWidth(0.1); // Thin line
        doc.line(cell.x, cell.y, cell.x + cell.width, cell.y); // Top border of each row
        doc.line(
          cell.x,
          cell.y + cell.height,
          cell.x + cell.width,
          cell.y + cell.height
        ); // Bottom border of each row

        // Draw vertical lines for columns
        doc.line(cell.x, cell.y, cell.x, cell.y + cell.height); // Left border of each column
        doc.line(
          cell.x + cell.width,
          cell.y,
          cell.x + cell.width,
          cell.y + cell.height
        ); // Right border of each column
      },
    });

    // Replace placeholder with actual total page count
    if (typeof doc.putTotalPages === "function") {
      doc.putTotalPages(totalPagesExp);
    }

    // Save the PDF
    doc.save(`${fileName}.pdf`);
  };

  return (
    <button onClick={handleExport} style={{ backgroundColor: "green" }}>
      {buttonTitle}
    </button>
  );
};

export default ExportToPDFCustomButton;
